import React from 'react'
import Skeleton from 'react-loading-skeleton'
import PropTypes from 'prop-types'

import SkeletonInputField from '../../../../../components/Form/InputField/Skeleton'

import useDrawerFormStyles from '../../../../../styles/common/drawerForms'

const SkeletonSingleSectionForm = ({ withTitle }) => {
  const drawerFormStyles = useDrawerFormStyles()

  return (
    <>
      {withTitle && (
        <h3 className={drawerFormStyles.formTitle}>
          <Skeleton width={190} />
        </h3>
      )}
      <section className={drawerFormStyles.section}>
        <h3 className={drawerFormStyles.sectionTitle}>
          <Skeleton width={130} />
        </h3>
        <p>
          <Skeleton width={230} />
        </p>
        <SkeletonInputField />
      </section>
    </>
  )
}

SkeletonSingleSectionForm.propTypes = {
  withTitle: PropTypes.bool
}

export default SkeletonSingleSectionForm
